import { Button, Text } from '@kidslabs/mario-nextjs-react-ui-core';
import { useTranslation } from 'next-i18next';
import { useAuth } from '../../hooks';
import { useCallback } from 'react';
import styles from './authentication-faq.module.css';

// This button is inside a form, so we must set type="button" to avoid unintended form submission (default is "submit")
export const AuthenticationFaqNavigator = () => {
    const { t } = useTranslation('auth');
    const { setCurrentStep } = useAuth();
    const setStep = useCallback(() => {
        setCurrentStep('Faq');
    }, [setCurrentStep]);

    return (
        <Button variant="outlined" type="button" className={styles.faqContainer} onClick={setStep}>
            <Text className={styles.text}>{t('text_problems_with_phone')}</Text>
        </Button>
    );
};
